import React, { useState } from 'react'
import myLogo from '../../assets/img/ayologo.svg'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router'

function Header() {

   const [logo, setLogo] = React.useState(false)
   const { pathname } = useLocation()
   console.log(pathname)

   return (
      <div id={pathname !=='/'?"header_work":"header"}>
         <div id="navigation">
            <div className="logo animated fadeInUp" onMouseOver={() => setLogo(true)} onMouseOut={() => setLogo(false)}>
               
               <Link to={"/"}>
                  {logo?
                  "David Ayọ"
                  :
                  <img className="image" src={myLogo} alt="logo" />
                  }
               </Link>
            </div>
            <ul className="navigation animated fadeInUp">
               <li>
                  <Link to={"/"}>
                     Work
                  </Link>
               </li>
               <li>
                  <Link to={"/About"}>
                     About
                  </Link>
               </li>
            </ul>
         </div>
      </div>
   )
}

export default Header